import { Patient } from "../system/AppState/AppPatientsState";

export function extractPatientContacts(patient: Patient) {
  const patientPhoneNumber =
    patient.mobilePhoneNumber ?? patient.homePhoneNumber ?? patient.phone3 ?? patient.phone4;

  const patientContacts = [
    ...(patientPhoneNumber === null
      ? []
      : [
          {
            firstName: patient.firstName,
            lastName: patient.lastName,
            emergencyPhoneNumber1: patientPhoneNumber,
          },
        ]),
    ...(patient.emergencyContact ?? []),
  ];

  return patientContacts;
}
